import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Container, Typography, Box } from '@mui/material'
import { useAuth } from '../contexts/AuthContext'
import AppHeader from '../components/common/AppHeader'
import ImageCombiner from '../components/photoTools/ImageCombiner'

const PhotoCombinePage: React.FC = () => {
  const navigate = useNavigate()
  const { user, logout, isAdmin } = useAuth()

  const handleBackClick = () => {
    navigate('/photo-tools')
  }

  return (
    <>
      <AppHeader
        title="Combine Tool"
        username={user?.username}
        showAdminButton={isAdmin}
        showBackButton
        onBackClick={handleBackClick}
        onLogout={logout}
      />

      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Typography variant="h4" gutterBottom>
            Combine Tool
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Połącz wiele obrazów w jeden z podpisami
          </Typography>
        </Box>

        <ImageCombiner />
      </Container>
    </>
  )
}

export default PhotoCombinePage
